export default __webpack_public_path__ + "static/media/6.11812358.png";